define('paychex.app.messages/services/module',[
    'angular',
    'paychex.app.messages/services/Constants',
    'paychex.app.messages/services/MessageListModelService',
    'paychex.app.messages/services/MessageListDataService',
    'paychex.app.messages/services/ParseMarkupService',
    'paychex.app.messages/services/MessageListPdfGenerationService',
    'paychex.app.common/data',
    'paychex.app.common/services',
    'paychex.framework.angular.utils/module',
    'paychex.framework.angular.data/module'
], function (angular,
             Constants,
             MessageListModelService,
             MessageListDataService,
             ParseMarkupService,
             MessageListPdfGenerationService,
             pacDataModule,
             pacServicesModule,
             pngUtilsModule,
             pngDataModule) {
    'use strict';

    /**
     * @namespace paychex.app.messages.services
     * @description Provides the MessagesService and GetMessagesService Angular components.
     */
    return angular.module('paychex.app.messages.services', [
        'ng',
        pacDataModule.name,
        pacServicesModule.name,
        pngUtilsModule.name,
        pngDataModule.name
    ])
        .service(Constants.MessageListModelServiceName, MessageListModelService)
        .service(Constants.MessageListDataServiceName, MessageListDataService)
        .service(Constants.ParseMarkupService, ParseMarkupService)
        .service(Constants.MessageListPdfGenerationServiceName, MessageListPdfGenerationService);

});

